<template>
  <b-card header-tag="header" class="mb-2">
      <div slot="header">
        <h4><font-awesome-icon icon="star" v-if="studentOpportunity"/>{{ opportunity.translationalTeam ? (opportunity.translationalTeam.name + ' @ ' ) : ''}}{{ opportunity.site.name }}</h4>
        <h5 v-if="opportunity.name">{{opportunity.name}}</h5>
        <h5>{{ opportunity.term.description }}</h5>
        <div>
          <b-badge variant="gray">{{ opportunity.opportunityType.name }}</b-badge>
          <b-badge v-if="opportunity.opportunityType.name == 'Translational Team'" class="ml-1" variant="gray">{{ opportunity.opportunityCategory.name }}</b-badge>
        </div>
      </div>
      <b-row>
        <b-col>
            <b-alert class="m-sm-2 mt-2" variant="danger" :show="!opportunity.available && ((studentOpportunity && !studentOpportunity.primarySelection) || !studentOpportunity) ">
              This opportunity is no longer available.
            </b-alert>
        </b-col>
      </b-row>
      <b-row>
        
        <b-col sm="10">

          <p class="card-text">
            <span style="display:block" v-if="opportunity.site.website"><a :href="opportunity.site.website" target="_blank">{{ opportunity.site.website }}</a></span>  
            <span style="display:block;font-weight:bold">
              {{opportunity.site.streetAddress}} {{opportunity.site.city}}, {{opportunity.site.state}} {{opportunity.site.zip}}
            </span>
          </p>

          <show-more v-if="opportunity.description" :text="opportunity.description"></show-more>
          
          <b-row>
            <b-col sm="6">
              <p class="card-text">
                <b-badge variant="gray" class="mr-2" v-for="oai in opportunity.opportunityAreaOfInterests" :key="oai.opportunityAreaOfInterestId">{{ oai.areaOfInterest.name }}</b-badge>
              </p>
              
              <p class="card-text">
                <b-badge variant="gray" class="mr-2"  v-for="oic in opportunity.opportunityInternshipCourses" :key="oic.internshipCourseId">{{ oic.internshipCourse.displayName }}</b-badge>
              </p>
            </b-col>
          </b-row>
        </b-col>

        <b-col sm="2" class="text-right">
          <router-link v-if="!studentOpportunity" :to="{ name: 'opportunityDetails', params: { id: opportunity.opportunityId } }">
            <b-button variant="primary">View Details</b-button>
          </router-link>
          <div v-if="studentOpportunity" class="student-opportunity-div">
            <!-- <div class="mb-2 font-weight-bold">{{ studentOpportunity.studentOpportunityStatus.name }}</div> -->
            
            <router-link v-if="studentOpportunity"
                         :to="{ name: 'studentOpportunityDetails',
                                params: { id: opportunity.opportunityId, studentOpportunityId: studentOpportunity.studentOpportunityId } }">
              <b-button class="mb-2" variant="primary">View Details</b-button>
            </router-link>

            <div class="mb-2" v-if="!studentOpportunity.primarySelection && opportunity.available">
              <b-button variant="primary" @click="setPrimaryIntent(studentOpportunity.studentOpportunityId)">Start Intent</b-button>
            </div>

            

            <div class="mb-2">
              <a href="" @click.prevent="removeOpportunity(studentOpportunity.studentOpportunityId)">Remove</a>
            </div>
          </div>
          
        </b-col>
      </b-row>
  </b-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import * as _ from "lodash"; // eslint-disable-line no-unused-vars
import ShowMore from "../show-more";
import moment from "moment";

export default {
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      filter: ""
    };
  },

  components: {
    "show-more": ShowMore
  },

  computed: {
    ...mapState({
      user: state => state.auth.user
    }),
    categoryName: function() {
      return this.opportunity.opportunityCategory
        ? this.opportunity.opportunityCategory.name
        : "";
    },
  },

  props: {
    opportunity: {
      type: Object,
      required: true
    },
    studentOpportunity: {
      type: Object,
      required: false
    }
  },

  methods: {
    setPrimaryIntent(studentOppId) {
      console.log("Setting primary intent");
      this.setIntent({
        studentOpportunityId: studentOppId,
        userId: this.user.userId
      });
    },

    removeOpportunity(studentOppId) {
      console.log("Removing opportunity");
      this.remove({
        studentOpportunityId: studentOppId,
        userId: this.user.userId
      });
    },

    ...mapActions("placements", {
      remove: "removeOpportunity",
      setIntent: "setPrimaryIntent"
    })
  }
};
</script>

<style scoped>
.filter-group {
  margin: 10px 0 15px 0;
  max-width: 600px;
}

.new-content-button {
  margin-left: 10px;
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}
.card-body {
  padding: 1.25rem;
}
</style>
